var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprovals2Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M606.7,327L844.8,93.7c9.5-9.5,19-14.3,33.3-14.3s23.8,4.8,33.3,14.3s14.3,19,14.3,33.3s-4.8,23.8-14.3,33.3L640,431.8 c-9.5,9.5-19,14.3-33.3,14.3c-14.3,0-23.8-4.8-33.3-14.3L435.2,293.7c-9.5-9.5-14.3-19-14.3-33.3s4.8-23.8,14.3-33.3 c9.5-9.5,19-14.3,33.3-14.3c14.3,0,23.8,4.8,33.3,14.3L606.7,327z M659,903.2l281-85.7c-4.8-9.5-9.5-14.3-19-19s-14.3-9.5-23.8-9.5 H659c-23.8,0-38.1,0-52.4-4.8s-23.8-4.8-38.1-9.5l-66.7-23.8c-14.3-4.8-23.8-9.5-28.6-23.8c-4.8-9.5-4.8-23.8,0-38.1 c4.8-14.3,9.5-23.8,23.8-28.6c9.5-4.8,23.8-4.8,38.1-4.8l47.6,14.3c14.3,4.8,28.6,9.5,47.6,9.5c19,0,38.1,4.8,71.4,4.8h14.3 c0-9.5-4.8-19-9.5-23.8c-4.8-9.5-9.5-14.3-19-14.3L411.4,541.3h-76.2v261.9L659,903.2z M630.5,998.5l-304.8-85.7 c-4.8,19-19,38.1-38.1,47.6c-19,14.3-38.1,19-57.1,19h-95.2c-23.8,0-47.6-9.5-66.7-28.6S40,908,40,884.2V550.8 c0-23.8,9.5-47.6,28.6-66.7c19-19,42.9-28.6,66.7-28.6h266.7c4.8,0,9.5,0,19,0c4.8,0,9.5,4.8,14.3,4.8l281,104.8 c23.8,9.5,47.6,23.8,61.9,47.6c14.3,23.8,23.8,52.4,23.8,81h95.2c38.1,0,71.4,14.3,100,38.1c28.6,28.6,42.9,61.9,42.9,104.8 c0,19-4.8,33.3-14.3,42.9c-9.5,9.5-23.8,19-42.9,23.8l-295.2,90.5c-9.5,4.8-19,4.8-28.6,4.8C649.5,1003.2,640,998.5,630.5,998.5z  M135.2,884.2h95.2V550.8h-95.2V884.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovals2Black);
export default __webpack_public_path__ + "static/media/approvals-2-black.b14d1da72f8cce063ee512faf35896fe.svg";
export { ForwardRef as ReactComponent };